//# sourceMappingURL=paragraph.mjs.map
/// <reference types="./paragraph.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $bool from "../../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $list from "../../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../../gleam_stdlib/gleam/string.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $h from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import * as $checkbox from "../../data/docx/checkbox.mjs";
import * as $document_context from "../../data/docx/document_context.mjs";
import * as $kind from "../../data/docx/kind.mjs";
import * as $numbering from "../../data/docx/numbering.mjs";
import * as $page_break from "../../data/docx/page_break.mjs";
import * as $text from "../../data/docx/text.mjs";
import * as $decrypt from "../../decrypt.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
} from "../../gleam.mjs";

export class ParagraphRun extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ParagraphElement$ParagraphRun = ($0) => new ParagraphRun($0);
export const ParagraphElement$isParagraphRun = (value) =>
  value instanceof ParagraphRun;
export const ParagraphElement$ParagraphRun$0 = (value) => value[0];

export class ParagraphCheckbox extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ParagraphElement$ParagraphCheckbox = ($0) =>
  new ParagraphCheckbox($0);
export const ParagraphElement$isParagraphCheckbox = (value) =>
  value instanceof ParagraphCheckbox;
export const ParagraphElement$ParagraphCheckbox$0 = (value) => value[0];

export class ParagraphListItem extends $CustomType {
  constructor($0) {
    super();
    this[0] = $0;
  }
}
export const ParagraphElement$ParagraphListItem = ($0) =>
  new ParagraphListItem($0);
export const ParagraphElement$isParagraphListItem = (value) =>
  value instanceof ParagraphListItem;
export const ParagraphElement$ParagraphListItem$0 = (value) => value[0];

export class Paragraph extends $CustomType {
  constructor(doc_context, tag, children, alignment, original_style, metadata, numbering_props) {
    super();
    this.doc_context = doc_context;
    this.tag = tag;
    this.children = children;
    this.alignment = alignment;
    this.original_style = original_style;
    this.metadata = metadata;
    this.numbering_props = numbering_props;
  }
}
export const Paragraph$Paragraph = (doc_context, tag, children, alignment, original_style, metadata, numbering_props) =>
  new Paragraph(doc_context,
  tag,
  children,
  alignment,
  original_style,
  metadata,
  numbering_props);
export const Paragraph$isParagraph = (value) => value instanceof Paragraph;
export const Paragraph$Paragraph$doc_context = (value) => value.doc_context;
export const Paragraph$Paragraph$0 = (value) => value.doc_context;
export const Paragraph$Paragraph$tag = (value) => value.tag;
export const Paragraph$Paragraph$1 = (value) => value.tag;
export const Paragraph$Paragraph$children = (value) => value.children;
export const Paragraph$Paragraph$2 = (value) => value.children;
export const Paragraph$Paragraph$alignment = (value) => value.alignment;
export const Paragraph$Paragraph$3 = (value) => value.alignment;
export const Paragraph$Paragraph$original_style = (value) =>
  value.original_style;
export const Paragraph$Paragraph$4 = (value) => value.original_style;
export const Paragraph$Paragraph$metadata = (value) => value.metadata;
export const Paragraph$Paragraph$5 = (value) => value.metadata;
export const Paragraph$Paragraph$numbering_props = (value) =>
  value.numbering_props;
export const Paragraph$Paragraph$6 = (value) => value.numbering_props;

export class Left extends $CustomType {}
export const Alignment$Left = () => new Left();
export const Alignment$isLeft = (value) => value instanceof Left;

export class Center extends $CustomType {}
export const Alignment$Center = () => new Center();
export const Alignment$isCenter = (value) => value instanceof Center;

export class Right extends $CustomType {}
export const Alignment$Right = () => new Right();
export const Alignment$isRight = (value) => value instanceof Right;

export class Justify extends $CustomType {}
export const Alignment$Justify = () => new Justify();
export const Alignment$isJustify = (value) => value instanceof Justify;

export class Metadata extends $CustomType {
  constructor(kind) {
    super();
    this.kind = kind;
  }
}
export const Metadata$Metadata = (kind) => new Metadata(kind);
export const Metadata$isMetadata = (value) => value instanceof Metadata;
export const Metadata$Metadata$kind = (value) => value.kind;
export const Metadata$Metadata$0 = (value) => value.kind;

export function is_virtual_paragraph(paragraph) {
  let $ = paragraph.tag;
  if ($ === "ul") {
    return true;
  } else if ($ === "ol") {
    return true;
  } else {
    return false;
  }
}

function empty_metadata() {
  return new Metadata(new None());
}

function metadata_decoder() {
  return $decrypt.optional_field(
    "kind",
    $kind.decoder(),
    (kind) => { return $decode.success(new Metadata(kind)); },
  );
}

function alignment_decoder() {
  return $decode.then$(
    $decode.string,
    (string) => {
      if (string === "left") {
        return $decode.success(new Left());
      } else if (string === "center") {
        return $decode.success(new Center());
      } else if (string === "right") {
        return $decode.success(new Right());
      } else if (string === "justify") {
        return $decode.success(new Justify());
      } else {
        return $decode.failure(new Left(), "alignment");
      }
    },
  );
}

function paragraph_element_decoder() {
  return $decode.field(
    "type",
    $decode.string,
    (type_) => {
      if (type_ === "run") {
        let _pipe = $text.run_decoder();
        return $decode.map(_pipe, (var0) => { return new ParagraphRun(var0); });
      } else if (type_ === "checkbox") {
        let _pipe = $checkbox.decoder();
        return $decode.map(
          _pipe,
          (var0) => { return new ParagraphCheckbox(var0); },
        );
      } else if (type_ === "list_item") {
        let _pipe = $decode.at(toList(["paragraph"]), decoder());
        return $decode.map(
          _pipe,
          (var0) => { return new ParagraphListItem(var0); },
        );
      } else {
        return $decode.failure(
          new ParagraphRun(new $text.Run(toList([]), new $option.None())),
          "paragraph_element",
        );
      }
    },
  );
}

export function decoder() {
  return $decode.field(
    "doc_context",
    $document_context.decoder(),
    (doc_context) => {
      return $decode.field(
        "html_tag",
        $decode.string,
        (tag) => {
          return $decrypt.optional_field(
            "children",
            $decode.list(paragraph_element_decoder()),
            (children) => {
              let children$1 = $option.unwrap(children, toList([]));
              return $decrypt.optional_field(
                "alignment",
                alignment_decoder(),
                (alignment) => {
                  let alignment$1 = $option.unwrap(alignment, new Left());
                  return $decrypt.optional_field(
                    "original_style",
                    $decode.string,
                    (original_style) => {
                      let original_style$1 = $option.unwrap(original_style, "");
                      return $decrypt.optional_field(
                        "metadata",
                        metadata_decoder(),
                        (metadata) => {
                          let metadata$1 = $option.lazy_unwrap(
                            metadata,
                            empty_metadata,
                          );
                          return $decrypt.optional_field(
                            "numbering_props",
                            $numbering.decoder(),
                            (numbering_props) => {
                              return $decode.success(
                                new Paragraph(
                                  doc_context,
                                  tag,
                                  children$1,
                                  alignment$1,
                                  original_style$1,
                                  metadata$1,
                                  numbering_props,
                                ),
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function numbering_format_docx_to_html(docx_format) {
  if (docx_format === "decimal") {
    return "1";
  } else if (docx_format === "upperLetter") {
    return "A";
  } else if (docx_format === "lowerLetter") {
    return "a";
  } else if (docx_format === "upperRoman") {
    return "I";
  } else if (docx_format === "lowerRoman") {
    return "i";
  } else {
    return docx_format;
  }
}

/**
 * The browser only numbers an `<ol>` from the standard `type` attribute, while
 * the editor's `Index` extension only declares `format` — and TipTap drops any
 * attribute an extension does not declare. Emitting both is what keeps the
 * numbering alive in either direction.
 * 
 * @ignore
 */
function numbering_format_attributes(docx_format) {
  let format = numbering_format_docx_to_html(docx_format);
  return toList([$a.attribute("type", format), $a.attribute("format", format)]);
}

function alignment_to_string(alignment) {
  if (alignment instanceof Left) {
    return "left";
  } else if (alignment instanceof Center) {
    return "center";
  } else if (alignment instanceof Right) {
    return "right";
  } else {
    return "justify";
  }
}

export function to_html(paragraph) {
  let doc_context_attrs = $document_context.to_html_attributes(
    paragraph.doc_context,
  );
  let alignment = alignment_to_string(paragraph.alignment);
  let alignment_attr = $a.attribute("data-alignment", alignment);
  let style_attr = $a.attribute("data-original-style", paragraph.original_style);
  let _block;
  let $ = paragraph.numbering_props;
  if ($ instanceof Some) {
    let $1 = $[0];
    if ($1 instanceof $numbering.FullNumberingProps) {
      let num = $1;
      let num_id = $a.attribute("num-id", $int.to_string(num.num_id));
      let level = $a.attribute("level", $int.to_string(num.level));
      let abstract_num_id = $a.attribute(
        "abstract-num-id",
        $int.to_string(num.abstract_num_id),
      );
      let format = numbering_format_attributes(num.format);
      _block = listPrepend(
        num_id,
        listPrepend(level, listPrepend(abstract_num_id, format)),
      );
    } else {
      let format = $1.format;
      _block = numbering_format_attributes(format);
    }
  } else {
    _block = toList([]);
  }
  let numbering_attributes = _block;
  let _block$1;
  let _pipe = doc_context_attrs;
  let _pipe$1 = $list.append(_pipe, toList([alignment_attr, style_attr]));
  _block$1 = $list.append(_pipe$1, numbering_attributes);
  let attributes = _block$1;
  return $h.element(
    paragraph.tag,
    attributes,
    $list.map(
      paragraph.children,
      (child) => { return paragraph_element_to_html(child); },
    ),
  );
}

function paragraph_element_to_html(element) {
  if (element instanceof ParagraphRun) {
    let run = element[0];
    return $text.run_to_html(run);
  } else if (element instanceof ParagraphCheckbox) {
    let checkbox = element[0];
    return $checkbox.to_html(checkbox);
  } else {
    let paragraph = element[0];
    return to_html(paragraph);
  }
}

function numbering_format_html_to_docx(html_format) {
  if (html_format === "1") {
    return "decimal";
  } else if (html_format === "A") {
    return "upperLetter";
  } else if (html_format === "a") {
    return "lowerLetter";
  } else if (html_format === "I") {
    return "upperRoman";
  } else if (html_format === "i") {
    return "lowerRoman";
  } else {
    return html_format;
  }
}

/**
 * Counterpart of `numbering_format_attributes`: read whichever of the two
 * attributes survived the round-trip.
 * 
 * @ignore
 */
function extract_numbering_format(element) {
  let _pipe = $html_parser.extract_attribute("type", element);
  let _pipe$1 = $result.lazy_or(
    _pipe,
    () => { return $html_parser.extract_attribute("format", element); },
  );
  return $result.map(_pipe$1, numbering_format_html_to_docx);
}

export function list_item_kind(item, parent) {
  let $ = item.metadata.kind;
  if ($ instanceof Some) {
    let k = $[0];
    if (!(k instanceof $kind.Other)) {
      return k;
    } else {
      return $option.unwrap(parent.metadata.kind, new $kind.Other());
    }
  } else {
    return $option.unwrap(parent.metadata.kind, new $kind.Other());
  }
}

function labelling_node(paragraph, element_kind) {
  let content = to_html(paragraph);
  let _block;
  let _pipe = $kind.to_string(element_kind);
  _block = ((_capture) => { return $a.attribute("kind", _capture); })(_pipe);
  let kind_attr = _block;
  let index_attr = $a.attribute(
    "data-index",
    $int.to_string(paragraph.doc_context.index),
  );
  return $h.element(
    "document-labeller",
    toList([kind_attr, index_attr]),
    toList([content]),
  );
}

function is_paragraph_element_empty(element) {
  if (element instanceof ParagraphRun) {
    let run = element[0];
    return $list.all(
      run.children,
      (child) => {
        if (child instanceof $text.RunText) {
          let content = child.content;
          return content === "";
        } else {
          return true;
        }
      },
    );
  } else if (element instanceof ParagraphCheckbox) {
    let c = element[0];
    return $option.unwrap(c.symbol, "") === "";
  } else {
    let p = element[0];
    return $list.all(p.children, is_paragraph_element_empty);
  }
}

export function is_empty(paragraph) {
  return $list.all(
    paragraph.children,
    (child) => { return is_paragraph_element_empty(child); },
  );
}

/**
 * A labelled list item must carry its own `<ul>`/`<ol>` parent: a bare `<li>`
 * leaves ProseMirror to auto-wrap it, and it always guesses a bullet list — so
 * a numbered docx list came back as bullets. Each labelled block holds exactly
 * one item, hence a single-item list carrying that item's identity.
 * 
 * @ignore
 */
function as_single_item_list(item, parent) {
  return new Paragraph(
    item.doc_context,
    parent.tag,
    toList([new ParagraphListItem(item)]),
    parent.alignment,
    parent.original_style,
    parent.metadata,
    (() => {
      let _pipe = parent.numbering_props;
      return $option.or(_pipe, item.numbering_props);
    })(),
  );
}

export function to_labelling(paragraph) {
  let $ = is_virtual_paragraph(paragraph);
  if ($) {
    return $list.filter_map(
      paragraph.children,
      (child) => {
        if (child instanceof ParagraphListItem) {
          let item = child[0];
          return $bool.guard(
            is_empty(item),
            new Error(undefined),
            () => {
              let wrapped = as_single_item_list(item, paragraph);
              return new Ok(
                labelling_node(wrapped, list_item_kind(item, paragraph)),
              );
            },
          );
        } else {
          return new Error(undefined);
        }
      },
    );
  } else {
    return $bool.guard(
      is_empty(paragraph),
      toList([]),
      () => {
        return toList([
          labelling_node(
            paragraph,
            (() => {
              let _pipe = paragraph.metadata.kind;
              return $option.unwrap(_pipe, new $kind.Other());
            })(),
          ),
        ]);
      },
    );
  }
}

function encode_alignment(alignment) {
  if (alignment instanceof Left) {
    return $json.string("left");
  } else if (alignment instanceof Center) {
    return $json.string("center");
  } else if (alignment instanceof Right) {
    return $json.string("right");
  } else {
    return $json.string("justify");
  }
}

export function encode(paragraph) {
  return $json.object(
    toList([
      ["type", $json.string("paragraph")],
      ["doc_context", $document_context.encode(paragraph.doc_context)],
      ["html_tag", $json.string(paragraph.tag)],
      ["children", $json.array(paragraph.children, encode_paragraph_element)],
      ["alignment", encode_alignment(paragraph.alignment)],
      ["original_style", $json.string(paragraph.original_style)],
      [
        "metadata",
        $json.object(
          toList([
            [
              "kind",
              $json.nullable(
                paragraph.metadata.kind,
                (a) => { return $json.string($kind.to_string(a)); },
              ),
            ],
          ]),
        ),
      ],
      [
        "numbering_props",
        $json.nullable(paragraph.numbering_props, $numbering.encode),
      ],
    ]),
  );
}

function encode_paragraph_element(element) {
  if (element instanceof ParagraphRun) {
    let run = element[0];
    return $text.encode_run(run);
  } else if (element instanceof ParagraphCheckbox) {
    let checkbox = element[0];
    return $checkbox.encode(checkbox);
  } else {
    let paragraph = element[0];
    return $json.object(
      toList([
        ["type", $json.string("list_item")],
        ["paragraph", encode(paragraph)],
      ]),
    );
  }
}

function alignment_from_string(alignment) {
  if (alignment === "center") {
    return new Center();
  } else if (alignment === "justify") {
    return new Justify();
  } else if (alignment === "left") {
    return new Left();
  } else if (alignment === "right") {
    return new Right();
  } else {
    return new Left();
  }
}

function extract_numbering(html_element) {
  let num_id = $html_parser.extract_attribute("num-id", html_element);
  if (num_id instanceof Ok) {
    let num_id_str = num_id[0];
    return $result.try$(
      $int.parse(num_id_str),
      (num_id_val) => {
        let level = $html_parser.extract_attribute("level", html_element);
        return $result.try$(
          level,
          (level_val) => {
            return $result.try$(
              $int.parse(level_val),
              (level_val) => {
                let abstract_num_id = $html_parser.extract_attribute(
                  "abstract-num-id",
                  html_element,
                );
                return $result.try$(
                  abstract_num_id,
                  (abstract_num_id_val) => {
                    return $result.try$(
                      $int.parse(abstract_num_id_val),
                      (abstract_num_id_val) => {
                        return $result.try$(
                          extract_numbering_format(html_element),
                          (format_val) => {
                            return new Ok(
                              new $numbering.FullNumberingProps(
                                num_id_val,
                                level_val,
                                abstract_num_id_val,
                                format_val,
                              ),
                            );
                          },
                        );
                      },
                    );
                  },
                );
              },
            );
          },
        );
      },
    );
  } else {
    return $result.try$(
      extract_numbering_format(html_element),
      (format_val) => {
        return new Ok(new $numbering.EditorNumberingProps(format_val));
      },
    );
  }
}

function extract_paragraph_attributes(tag, children, element) {
  let doc_context = $document_context.from_html_attributes(element);
  let _block;
  let _pipe = $html_parser.extract_attribute("data-original-style", element);
  _block = $result.unwrap(_pipe, "");
  let original_style = _block;
  let _block$1;
  let _pipe$1 = $html_parser.extract_attribute("data-alignment", element);
  let _pipe$2 = $result.unwrap(_pipe$1, "");
  _block$1 = alignment_from_string(_pipe$2);
  let alignment = _block$1;
  let _block$2;
  let _pipe$3 = extract_numbering(element);
  _block$2 = $option.from_result(_pipe$3);
  let numbering_props = _block$2;
  return new Paragraph(
    doc_context,
    tag,
    children,
    alignment,
    original_style,
    new Metadata(new None()),
    numbering_props,
  );
}

export function parse_style_attribute(style_str) {
  return $bool.guard(
    $string.is_empty(style_str),
    toList([]),
    () => {
      let _pipe = style_str;
      let _pipe$1 = $string.trim(_pipe);
      let _pipe$2 = $string.split(_pipe$1, ";");
      let _pipe$3 = $list.map(_pipe$2, $string.trim);
      return $list.filter_map(
        _pipe$3,
        (declaration) => {
          return $bool.guard(
            $string.is_empty(declaration),
            new Error(undefined),
            () => {
              let parts = $string.split(declaration, ":");
              return $result.try$(
                (() => {
                  if (parts instanceof $Empty) {
                    return new Error(undefined);
                  } else {
                    let $ = parts.tail;
                    if ($ instanceof $Empty) {
                      return new Error(undefined);
                    } else {
                      let $1 = $.tail;
                      if ($1 instanceof $Empty) {
                        let p = parts.head;
                        let v = $.head;
                        return new Ok([p, v]);
                      } else {
                        return new Error(undefined);
                      }
                    }
                  }
                })(),
                (_use0) => {
                  let property = _use0[0];
                  let value = _use0[1];
                  let property$1 = $string.trim(property);
                  let value$1 = $string.trim(value);
                  return $bool.guard(
                    $string.is_empty(property$1) || $string.is_empty(value$1),
                    new Error(undefined),
                    () => { return new Ok([property$1, value$1]); },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function style_for_tag(tag) {
  if (tag === "strong") {
    return toList([["font-weight", "bold"]]);
  } else if (tag === "b") {
    return toList([["font-weight", "bold"]]);
  } else if (tag === "em") {
    return toList([["font-style", "italic"]]);
  } else if (tag === "i") {
    return toList([["font-style", "italic"]]);
  } else if (tag === "u") {
    return toList([["text-decoration", "underline"]]);
  } else {
    return toList([]);
  }
}

function do_extract_runs(element, styles) {
  if (element instanceof $html_parser.EmptyElement) {
    return toList([]);
  } else if (element instanceof $html_parser.StartElement) {
    let $ = element.name;
    if ($ === "br") {
      let break_elem = new $page_break.PageBreak(
        new None(),
        new $page_break.Line(),
        "",
        new $page_break.Metadata(new None()),
      );
      let run = new $text.Run(
        toList([new $text.RunBreak(break_elem)]),
        new Some(styles),
      );
      return toList([new ParagraphRun(run)]);
    } else {
      let tag = $;
      let children = element.children;
      let tag_styles = style_for_tag(tag);
      let _block;
      if (tag === "span") {
        let _pipe = $html_parser.extract_attribute("style", element);
        let _pipe$1 = $result.map(_pipe, parse_style_attribute);
        _block = $result.unwrap(_pipe$1, toList([]));
      } else {
        _block = toList([]);
      }
      let inline_styles = _block;
      let _block$1;
      let _pipe = styles;
      let _pipe$1 = $list.append(_pipe, tag_styles);
      _block$1 = $list.append(_pipe$1, inline_styles);
      let styles$1 = _block$1;
      return $list.flat_map(
        children,
        (child) => { return do_extract_runs(child, styles$1); },
      );
    }
  } else if (element instanceof $html_parser.EndElement) {
    return toList([]);
  } else {
    let content = element[0];
    let content$1 = new $text.RunText(content);
    let run = new $text.Run(toList([content$1]), new Some(styles));
    return toList([new ParagraphRun(run)]);
  }
}

function extract_runs(element) {
  return do_extract_runs(element, toList([]));
}

function add_numbering(paragraph, tag) {
  return new Paragraph(
    paragraph.doc_context,
    paragraph.tag,
    $list.map(
      paragraph.children,
      (child) => {
        if (child instanceof ParagraphRun) {
          return child;
        } else if (child instanceof ParagraphCheckbox) {
          return child;
        } else {
          let item = child[0];
          return new ParagraphListItem(
            new Paragraph(
              item.doc_context,
              item.tag,
              item.children,
              item.alignment,
              item.original_style,
              item.metadata,
              (() => {
                let $ = item.numbering_props;
                if ($ instanceof None) {
                  if (tag === "ul") {
                    return new Some(
                      new $numbering.EditorNumberingProps("bullet"),
                    );
                  } else if (tag === "ol") {
                    return new Some(
                      new $numbering.EditorNumberingProps("decimal"),
                    );
                  } else {
                    return item.numbering_props;
                  }
                } else {
                  return item.numbering_props;
                }
              })(),
            ),
          );
        }
      },
    ),
    paragraph.alignment,
    paragraph.original_style,
    paragraph.metadata,
    paragraph.numbering_props,
  );
}

function extract_list_item(elements) {
  return $list.filter_map(
    elements,
    (element) => {
      if (element instanceof $html_parser.EmptyElement) {
        return new Error(undefined);
      } else if (element instanceof $html_parser.StartElement) {
        let name = element.name;
        if (name !== "li") {
          return new Error(undefined);
        } else {
          let children = element.children;
          return new Ok(
            (() => {
              let _pipe = children;
              let _pipe$1 = $list.flat_map(_pipe, extract_runs);
              let _pipe$2 = ((_capture) => {
                return extract_paragraph_attributes("li", _capture, element);
              })(_pipe$1);
              return new ParagraphListItem(_pipe$2);
            })(),
          );
        }
      } else if (element instanceof $html_parser.EndElement) {
        return new Error(undefined);
      } else {
        return new Error(undefined);
      }
    },
  );
}

export function from_element(element) {
  if (element instanceof $html_parser.EmptyElement) {
    return new Error(undefined);
  } else if (element instanceof $html_parser.StartElement) {
    let $ = element.name;
    if ($ === "table") {
      return new Error(undefined);
    } else if ($ === "ul") {
      let tag = $;
      let children = element.children;
      let children$1 = extract_list_item(children);
      let _pipe = extract_paragraph_attributes(tag, children$1, element);
      let _pipe$1 = add_numbering(_pipe, tag);
      return new Ok(_pipe$1);
    } else if ($ === "ol") {
      let tag = $;
      let children = element.children;
      let children$1 = extract_list_item(children);
      let _pipe = extract_paragraph_attributes(tag, children$1, element);
      let _pipe$1 = add_numbering(_pipe, tag);
      return new Ok(_pipe$1);
    } else {
      let children = extract_runs(element);
      return new Ok(extract_paragraph_attributes("p", children, element));
    }
  } else if (element instanceof $html_parser.EndElement) {
    let children = extract_runs(element);
    return new Ok(extract_paragraph_attributes("p", children, element));
  } else {
    let children = extract_runs(element);
    return new Ok(extract_paragraph_attributes("p", children, element));
  }
}

function add_missing_paragraph_tag(html) {
  let is_correctly_formatted = $string.starts_with(html, "<");
  return $bool.guard(
    is_correctly_formatted,
    html,
    () => { return $string.join(toList(["<p>", html, "</p>"]), ""); },
  );
}

function parse_paragraph(html) {
  let _pipe = html;
  let _pipe$1 = $string.trim(_pipe);
  let _pipe$2 = add_missing_paragraph_tag(_pipe$1);
  return $html_parser.as_tree(_pipe$2);
}

export function from_html(html) {
  let element = parse_paragraph(html);
  return from_element(element);
}

export function update_kind(paragraph, kind) {
  let metadata = new Metadata(new Some(kind));
  return new Paragraph(
    paragraph.doc_context,
    paragraph.tag,
    paragraph.children,
    paragraph.alignment,
    paragraph.original_style,
    metadata,
    paragraph.numbering_props,
  );
}

export function list_format(paragraph) {
  let $ = paragraph.numbering_props;
  if ($ instanceof Some) {
    let $1 = $[0];
    if ($1 instanceof $numbering.FullNumberingProps) {
      let $2 = $1.format;
      if ($2 === "decimal") {
        return new Ok("ol");
      } else if ($2 === "bullet") {
        return new Ok("ul");
      } else if ($2 === "upperLetter") {
        return new Ok("ol");
      } else {
        return new Error(undefined);
      }
    } else {
      let $2 = $1.format;
      if ($2 === "decimal") {
        return new Ok("ol");
      } else if ($2 === "upperLetter") {
        return new Ok("ol");
      } else if ($2 === "bullet") {
        return new Ok("ul");
      } else {
        return new Error(undefined);
      }
    }
  } else {
    return new Error(undefined);
  }
}

export function as_list_item(paragraph) {
  return new Paragraph(
    paragraph.doc_context,
    "li",
    paragraph.children,
    paragraph.alignment,
    paragraph.original_style,
    paragraph.metadata,
    paragraph.numbering_props,
  );
}
